import React, { useState } from 'react';

const FAQ = () => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [faqs, setFaqs] = useState([]);
  const [message, setMessage] = useState('');

  const handleQuestionChange = (e) => {
    setQuestion(e.target.value);
  };

  const handleAnswerChange = (e) => {
    setAnswer(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (question && answer) {
      const newFaq = { question, answer };
      setFaqs([...faqs, newFaq]); // Add new FAQ to the list
      setMessage('FAQ added successfully!');
      setQuestion('');
      setAnswer('');
    } else {
      setMessage('Please provide both question and answer.');
    }
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '800px',
    margin: '0 auto',
    fontSize: '14px',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '8px',
    display: 'block',
  };

  const inputStyle = {
    padding: '8px',
    fontSize: '14px',
    width: '100%',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '20px',
  };

  const buttonStyle = {
    padding: '8px 16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '14px',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Add FAQ</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={labelStyle}>Question</label>
          <input
            type="text"
            value={question}
            onChange={handleQuestionChange}
            placeholder="Enter the question..."
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={labelStyle}>Answer</label>
          <input
            type="text"
            value={answer}
            onChange={handleAnswerChange}
            placeholder="Enter the answer..."
            style={inputStyle}
          />
        </div>

        <button type="submit" style={buttonStyle}>
          Submit
        </button>
      </form>

      {message && <div style={{ marginTop: '20px', color: 'green' }}>{message}</div>}

      <h3 style={{ textAlign: 'center', marginTop: '30px' }}>FAQ List</h3>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Question</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Answer</th>
          </tr>
        </thead>
        <tbody>
          {faqs.length > 0 ? (
            faqs.map((faq, index) => (
              <tr key={index}>
                <td style={thTdStyle}>{index + 1}</td>
                <td style={thTdStyle}>{faq.question}</td>
                <td style={thTdStyle}>{faq.answer}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={thTdStyle}>No FAQs available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FAQ;
